// extracted by mini-css-extract-plugin
export default {"badgeList":"BadgeList-badgeList_kwbTt"};